export default __webpack_public_path__ + "static/media/stek_dyno_shield.82ce4635.webp";